import styled from 'styled-components';

import { getPurpurSpacing, purpurMedia } from '@telialt/common-theme/src/purpurSelectors';

export const ButtonSuggestionWrapper = styled.div`
    margin: -${getPurpurSpacing('50')};
    padding: ${getPurpurSpacing('50')};
    display: flex;
    gap: ${getPurpurSpacing('100')};
    overflow-x: auto;
    overflow-y: visible;
    white-space: nowrap;
    scrollbar-width: none;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
        display: none;
    }

    ${purpurMedia('md')`
        gap: ${getPurpurSpacing('200')};
    `};

    ${purpurMedia('lg')`
        overflow: visible;
        white-space: normal;
        flex-wrap: wrap;
    `};
`;
